export default {
  SEARCH_ALLIANZ_EARNINGS_REPORT_QUERY: Symbol.for('SEARCH_ALLIANZ_EARNINGS_REPORT_QUERY'),
  ALLIANZ_EARNINGS_REPORT_REPOSITORY: Symbol.for('ALLIANZ_EARNINGS_REPORT_REPOSITORY'),
  ALLIANZ_EARNINGS_REPORT_STATE_MANAGER: Symbol.for('ALLIANZ_EARNINGS_REPORT_STATE_MANAGER'),
};
